// extracted by mini-css-extract-plugin
export default {"textarea_group":"Textarea_textarea_group__ZRL+G","textarea":"Textarea_textarea__svQaT","user_label":"Textarea_user_label__QXHCy","teaxtarea":"Textarea_teaxtarea__10o1Y"};